"use strict";
import Autolinker from "autolinker";
export function autolink(text) {
  return Autolinker.link(text, {
    newWindow: true,
    // Autolinker 4 links bare IP addresses like 192.168.1.1 by default.
    // Autolinker 1 only linked them with a scheme (http://192.168.1.1).
    urls: { ipV4Matches: false }
  });
}
